import React from 'react'
import styled from 'styled-components'

interface Props {
  text: string
  value: string
}

export function Parameter({ text, value }: Props) {
  return (
    <li>
      <Label>{text + ':'}</Label>
      <Value>{value}</Value>
    </li>
  )
}

export const Parameters = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
  font-size: 11px;

  li {
    margin-bottom: 3px;

    &:last-child {
      margin-bottom: 0;
    }
  }
`

const Label = styled.strong`
  margin-right: 5px;
  display: inline-block;
`

const Value = styled.span``
